<template>
	<div class="full">
		<el-tabs class="full flex" style="flex-direction: column;" v-model="activeName" type="card">
			<el-tab-pane label="库存信息" name="inventory">
				<div class="pane_container">
					<inventory :row="row"  :key="'inventory_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="盘点信息" name="inventoryquantityadjustbill">
				<div class="pane_container">
					<inventoryquantityadjustbill :row="row"  :key="'inventoryquantityadjustbill_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="产品资料" name="material">
				<div class="pane_container">
					<material :row="row" :list="list"  :key="'material_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="线上信息" name="online">
				<div class="pane_container">
					<online :row="row" :list="list"   />
				</div>
			</el-tab-pane>
			<el-tab-pane label="销量统计" name="salesstatic">
				<div class="pane_container">
					<salesstatic :row="row"  :key="'salesstatic_'+key" />
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.pane_container {
		position: relative;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px;
		overflow-y: auto;
		overflow-x: hidden;
		box-sizing: border-box;
	}
</style>
<script>
	import inventory from './inventory.vue';
	import inventoryquantityadjustbill from './inventoryquantityadjustbill.vue';
	import material from './material.vue';
	import online from './online.vue';
	import salesstatic from './salesstatic.vue';
	export default {
		props: {
			list: {
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				activeName: 'inventory',
				key: Math.random(),
				
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			onSubmit() {
				console.log('submit!');
			},
			inittab() {
				this.key = Math.random()
			}
		},
		components: {
			online,
			inventory,
			inventoryquantityadjustbill,
			salesstatic,
			material
		}
	}
</script>
